module.exports = __webpack_public_path__ + "bf0d14d6822521c1132a3884f9a2e718.svg";